/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactComponent as NotificationsIcon } from "../assets/layout-svg-icons/Notifications1.svg";
import KTOffcanvas from "../../_assets/js/offcanvas";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
function QuickPanelToggler({}) {
  const { totalNotification, reload } = useGlobalData();

  useEffect(() => {
    // eslint-disable-next-line
    const panel = document.getElementById("kt_quick_panel");

    // eslint-disable-next-line
    const offCanvas = new KTOffcanvas(panel, {
      overlay: true,
      baseClass: "kt-quick-panel",
      closeBy: "kt_quick_panel_close_btn",
      toggleBy: "kt_quick_panel_toggler_btn",
    });
  }, [reload]);

  const StyledBadge = withStyles((theme) => ({
    badge: {
      top: "0%",
      right: "0%",
      // The border color match the background color.
      border: `2px solid white}`,
    },
  }))(Badge);

  return (
    <React.Fragment>
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip className="tooltip-dark" id="Notification-tooltip">
            Notifications
          </Tooltip>
        }
      >
        <div
          className="kt-header__topbar-item kt-header__topbar-item--quick-panel"
          data-toggle="kt-tooltip"
          //title="Quick panel"
          data-placement="right"
        >
          <span
            className="kt-header__topbar-icon"
            id="kt_quick_panel_toggler_btn"
          >
            {totalNotification > 0 ? (
              <StyledBadge
                badgeContent={totalNotification}
                color="secondary"
                overlap="rectangular"
              >
                <NotificationsIcon />
              </StyledBadge>
            ) : (
              <NotificationsIcon />
            )}
          </span>
        </div>
      </OverlayTrigger>
    </React.Fragment>
  );
}

export default QuickPanelToggler;
